var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticClass: "ma-0 pa-0" },
    [
      _c("p-packages-edit-audience-popup", {
        ref: "p-packages-edit-audience-popup",
      }),
      _c("p-packages-edit-version-popup", {
        ref: "p-packages-edit-version-popup",
      }),
      _c(
        "v-card-actions",
        [
          _c(
            "v-card",
            {
              staticClass: "ma-0 pa-0",
              attrs: { elevation: "0", width: "100%", outlined: "" },
            },
            [
              _c("v-data-table", {
                staticStyle: { width: "100%" },
                attrs: {
                  "fixed-header": "",
                  items: _vm.deployedPackages,
                  headers: _vm.headers,
                  "hide-default-footer": "",
                  "disable-pagination": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.updated",
                    fn: function ({ item }) {
                      return [
                        _c("v-card-text", [
                          _vm._v(_vm._s(_vm._f("formatDate")(item.updated))),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "item.aud",
                    fn: function ({ item }) {
                      return [
                        _c(
                          "v-btn",
                          {
                            staticClass: "mr-1",
                            attrs: {
                              disabled:
                                !_vm.ifCanSetAudiencesForDeployedPackage(),
                              outlined: "",
                              color: "orange",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.onPressEditAudience(item)
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(item.aud) + " ")]
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.version",
                    fn: function ({ item }) {
                      return [
                        _c(
                          "v-btn",
                          {
                            staticClass: "mr-1",
                            attrs: {
                              disabled:
                                !_vm.ifCanSetVersionForDeployedPackage(),
                              outlined: "",
                              color: "green",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.onPressEditVersion(item)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(item.minver || "-") +
                                " - " +
                                _vm._s(item.maxver || "-") +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.actions",
                    fn: function ({ item }) {
                      return [
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function ({ on, attrs }) {
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass: "mr-1",
                                              attrs: {
                                                disabled:
                                                  !_vm.ifCanDeleteDeployedPackage(),
                                                loading: _vm.deleting.includes(
                                                  item.name
                                                ),
                                                icon: "",
                                                color: "red",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onPressDelete(item)
                                                },
                                              },
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { size: "22" } },
                                            [_vm._v("mdi-delete")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [_c("span", [_vm._v("Delete Package")])]
                        ),
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function ({ on, attrs }) {
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass: "mr-1",
                                              attrs: {
                                                disabled:
                                                  !_vm.ifCanDeployPackage(),
                                                icon: "",
                                                color: "blue",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onPressAddToDeploy(
                                                    item
                                                  )
                                                },
                                              },
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { size: "22" } },
                                            [_vm._v("mdi-folder-plus")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [_c("span", [_vm._v("Deploy package")])]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }